import { stegaClean } from "@sanity/client/stega";
import { GROQCTA } from "@/sanity/lib/definitions";
import { IPageLink, resolveCTA, resolvePageLink } from "@/sanity/globals/CTA";
import { IPopup } from "@/sanity/globals/Popups";

export function useCTAWrapper(cta: GROQCTA | null | undefined) {
  const cleanedCta = (stegaClean(cta ?? null) ?? null) as GROQCTA | null;

  const action = cleanedCta?.action ?? null;
  const actionData = resolveCTA(cleanedCta ?? null);

  const isLink = action === "link" && actionData;
  const link = isLink ? resolvePageLink(actionData as IPageLink | null) : null;

  const isAnchor = action === "anchor" && actionData;
  const anchor = isAnchor ? (actionData as string) : null;

  const isPopup = action === "popup" && actionData;
  const popup = isPopup ? (actionData as IPopup) : null;

  return {
    action,
    isLink,
    link,
    isAnchor,
    anchor,
    isPopup,
    popup,
  };
}